import type { WishlistItem } from "./contracts";
import { useEffect, useState } from "react";
import { productSearchImageUrl } from "../api/client";

export function WishlistItemRow({ item, managing, selected, onSelect }: { item: WishlistItem; managing: boolean; selected: boolean; onSelect: () => void }) {
  const [imageFailed, setImageFailed] = useState(false);
  useEffect(() => setImageFailed(false), [item.imageUrl]);
  return <article className={`wishlist-row${managing ? " is-managing" : ""}`}>
    <img src={!imageFailed && item.imageUrl ? productSearchImageUrl(item.imageUrl) : "/assets/products/image-placeholder.svg"} alt="" draggable={false} onError={() => setImageFailed(true)} />
    <span className="wishlist-item-copy"><small>{item.brand || "品牌资料待补充"}</small><strong>{item.nameCn || item.styleName}</strong>{item.nameEn ? <em>{item.nameEn}</em> : null}{item.identityKind === "commerce" ? <em>{item.specification ? `${item.specification} · ` : ""}已按商品收藏</em> : null}</span>
    {managing ? <label className="wishlist-check"><input type="checkbox" checked={selected} onChange={onSelect} /><i aria-hidden="true" /></label> : null}
  </article>;
}
